import styled from "@emotion/styled";
import { m } from "framer-motion";
import { mediaQuery } from "utils/index";

export const CollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding-top: 24px;
`;
export const CollapseContainer = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  ${({ theme }) =>
    `border-bottom: 1px solid ${theme.colorScheme.border.primary};`}
`;

export const CollapseBody = styled(m.div)`
  overflow: hidden;
  padding-top: 1px;
  padding-right: 26px;
  padding-bottom: 1px;
  @media ${mediaQuery.tabletMdUp} {
    padding-right: 96px;
  }
`;
